import React from 'react';
import { TopToolbar, ListButton } from 'react-admin';
import UpdateTrafficType from './UpdateTrafficType';

const AccountingAccountShowActions = ({ data }) => (
	<TopToolbar>
		{data && (
			<React.Fragment>
				<ListButton basePath={`/accountingAccountItems/?filter={"accountId":"${data.id}"}`} label="resources.accountingAccounts.actions.goToAccountingAccountItems" />
				<ListButton basePath={`/accountingAccountTransfers/?filter={"accountId":"${data.id}"}`} label="resources.accountingAccounts.actions.goToAccountingAccountTransfers" />
				<UpdateTrafficType record={data} />
			</React.Fragment>
		)}
	</TopToolbar>
);

export default AccountingAccountShowActions;
